import { render, staticRenderFns } from "./SwitchPartnerPanel.vue?vue&type=template&id=6ef51752&"
import script from "./SwitchPartnerPanel.vue?vue&type=script&lang=js&"
export * from "./SwitchPartnerPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports